// extracted by mini-css-extract-plugin
export var brand = "_8c-9";
export var compact = "_8c-6";
export var extraSmall = "_8c-7";
export var icon = "_8c-0";
export var large = "_8c-4";
export var light = "_8c-1";
export var medium = "_8c-5";
export var outline = "_8c-b";
export var primaryDark = "_8c-a";
export var primaryLight = "_8c-8";
export var primaryModern = "_8c-c";
export var success = "_8c-2";
export var successSolid = "_8c-3";